import { Country } from '@tiendanube/common/src/enums';
import { useNavegate } from '@tiendanube/stratus/src/App/hooks';
import HelpLink from 'App/HelpLink';
import {
  CancelAndSaveButtons,
  HeaderContent,
  IonPageStratus,
  Stack,
} from 'commons/components';
import { isValidRfc } from 'commons/utils/rfcValidation';
import { AuthenticationWithoutConfirmationModal } from 'domains/AuthenticationFactor';
import useTranslationPayments from 'domains/Payments/useTranslationPayments';
import {
  NuvempagoInitArgentineCard,
  NuvempagoInitMexicanCard,
  NuvempagoInitBrazilianCard,
  NuvempagoInitSettingsPageSkeleton,
} from './components';
import { canCountryLink } from './constants';
import useNuvempagoInitSettingsPage from './useNuvempagoInitSettingsPage';

const TRANSLATE_PREFIX = 'nuvempagoSettings';

function NuvempagoInitSettingsPage() {
  const t = useTranslationPayments(TRANSLATE_PREFIX);

  const {
    authenticationFactor,
    closeAuthenticationFactor,
    paymentProvider,
    country,
    errors,
    handleOnChange,
    handleOnSubmit,
    isLoading,
    updateLoading,
    values,
    handleConfirmAction,
  } = useNuvempagoInitSettingsPage();
  const { goBack } = useNavegate();

  const isMexico = country === Country.MX;

  const handleCancel = () => {
    if (isMexico) {
      goBack();
    } else {
      closeAuthenticationFactor();
    }
  };

  const getIsDisabled = () => {
    if (isMexico) {
      return !isValidRfc(values.document);
    }
    return false;
  };

  if (isLoading) return <NuvempagoInitSettingsPageSkeleton />;

  return (
    <IonPageStratus
      width="small"
      headerContent={<HeaderContent title={t('title')} />}
    >
      <Stack column align="flex-start">
        {country === Country.BR && (
          <NuvempagoInitBrazilianCard
            onChange={handleOnChange}
            document={values.document}
            error={errors.document}
          />
        )}
        {country === Country.AR && (
          <NuvempagoInitArgentineCard
            onChange={handleOnChange}
            document={values.document}
            error={errors.document}
          />
        )}
        {isMexico && (
          <NuvempagoInitMexicanCard
            onChange={handleOnChange}
            document={values.document}
            error={errors.document}
          />
        )}
        <Stack alignSelf="flex-end">
          <CancelAndSaveButtons
            onCancel={handleCancel}
            onSave={handleOnSubmit}
            saveText={t('enable')}
            isLoading={updateLoading}
            isDisabled={getIsDisabled()}
          />
        </Stack>
        <Stack alignSelf="center">
          {paymentProvider && !isMexico && (
            <HelpLink
              previousValue=""
              title={t('helpLink.title')}
              currentViewTracking={t('helpLink.amplitudeName')}
              linkURL={canCountryLink[country] || canCountryLink.default}
              icon="both"
              appearance="primary"
              showInMobile
            />
          )}
        </Stack>
      </Stack>
      {authenticationFactor && (
        <AuthenticationWithoutConfirmationModal
          onConfirm={handleConfirmAction}
          onCancel={closeAuthenticationFactor}
          payload={authenticationFactor}
        />
      )}
    </IonPageStratus>
  );
}

export default NuvempagoInitSettingsPage;
